import 'bootstrap/dist/css/bootstrap.min.css';
import { saveAs } from 'file-saver';
import { addLocale, FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import useParams from '../../helpers/useParams';
import useParamsHeadCount from '../../helpers/useParamsHeadCount';
import useParamsSalary from '../../helpers/useParamsSalary';
import dateFormat from '../../services/DateFormat.service';
import './PayrollPayment.css';
import '../../utils/icon.css';
import { Div, Form, FormGroup, H3, LabelField } from './PayrollPayment.styles';
import { useHistory } from "react-router-dom";
import Video from '../Video/Video';
import { Chart } from 'primereact/chart';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useParamsSocialBenefits from '../../helpers/useParamsSocialBenefits';
import ConfBar from '../ConfBar/ConfBar';
import { Avatar } from 'primereact/avatar';
import useParamsVacationCycle from '../../helpers/useParamsVacationCycle';
import { excelReport } from '../../services/excelReport.service';
import { excelExport } from '../../services/excelExport.service';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PayrollPayment
Description : Liquidación de nómina y generación de reportes.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

export default function PayrollPayment(props) {

    var _ = require('lodash'); //Para comparar objetos json
    let history = useHistory();


    /*Propiedades y listas de valores del componente*/
    const [tipoLiquidacion, setTipoLiquidacion] = useState("");
    const [tipoPlanoBancario, setTipoPlanoBancario] = useState("")
    const [fechaPago, setFechaPago] = useState("")
    const [consultado, setConsultado] = useState(false)
    const [listaLiquidacion, setListaLiquidacion] = useState([])
    const [listaPlanoBancario, setListaPlanoBancario] = useState([])

    /*Propiedades para los reportes del componente*/
    const [params] = useParams();
    const [salaryParams] = useParamsSalary();
    const [headCountParams] = useParamsHeadCount();
    const [socialBenefitsParams] = useParamsSocialBenefits()
    const [vacationCycleParams] = useParamsVacationCycle()
    const [nomina, setNomina] = useState([])
    const [historico, setHistorico] = useState([])
    const [headCount, setHeadCount] = useState([])
    const [prestaciones, setPrestaciones] = useState([])
    const [libroVaciones, setLibroVacaciones] = useState([])
    const [namePayrollBudget, setNamePayrollBudget] = useState('');
    const [datasetsPayrollBudget, setDatasetsPayrollBudget] = useState([]);
    const [labelPayrollBudget, setLabelPayrollBudget] = useState([]);
    const [loadPage, setLoadPage] = useState(false)

    /*Propiedades de los modales del componente*/
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenPB, setIsOpenPB] = React.useState(false);
    const [isOpenRN, setIsOpenRN] = React.useState(false);
    const [isOpenHS, setIsOpenHS] = React.useState(false);
    const [isOpenHC, setIsOpenHC] = React.useState(false);
    const [isOpenAcum, setIsOpenAcum] = React.useState(false);
    const [isOpenSB, setIsOpenSB] = React.useState(false);
    const [isOpenVC, setIsOpenVC] = React.useState(false);

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [loading5, setLoading5] = useState(false);
    const [loading6, setLoading6] = useState(false);
    const [loading7, setLoading7] = useState(false);
    const [loading8, setLoading8] = useState(false);
    const [loading9, setLoading9] = useState(false);
    const [loading10, setLoading10] = useState(false);
    const [loading11, setLoading11] = useState(false);

    /*Constantes globales para el componente*/
    const headers = {
        authorization: localStorage.getItem('token')
    }
    const elementWidth = { width: "20rem", justifySelf: "center" }
    const toast = useRef(null);

    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [rowsPlano, setRowsPlano] = useState([]);

    const [warningType, setWarningType] = useState("")

    const [warningRows, setWarningRows] = useState([]);
    const [warningFirst2, setWarningFirst2] = useState(0);
    const [warningRows2, setWarningRows2] = useState(10);

    const [errorRows, setErrorRows] = useState([])
    const [isOpenErrors, setIsOpenErrors] = useState(false)

    const [employees, setEmployees] = useState("")
    const [net, setNet] = useState("")
    const [rowDataTab, setRowDataTab] = useState([]);

    /*Formato para el calendario del componente*/
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        /*Se cargan los datos de las listas de valores del componente*/
        loadCalendar();
        setFechaPago(new Date())
    }, []);

    useEffect(() => {
        const payrollTemplate = async () => {
            /*Se inicializan las propiedades del reporte de nómina*/
            let plantilla = []
            params.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setNomina(plantilla)
        }
        payrollTemplate()
    }, [params]);

    useEffect(() => {
        const historicTemplate = async () => {
            /*Se inicializan las propiedades del reporte histórico de salarios*/
            let plantilla2 = []
            salaryParams.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla2.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla2.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setHistorico(plantilla2)
        }
        historicTemplate()
    }, [salaryParams]);

    useEffect(() => {
        const socialTemplate = async () => {
            /*Se inicializan las propiedades del reporte histórico de salarios*/
            let plantilla4 = []
            socialBenefitsParams.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla4.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla4.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setPrestaciones(plantilla4)
        }
        socialTemplate()
    }, [socialBenefitsParams]);

    useEffect(() => {
        const HCTemplate = async () => {
            /*Se inicializan las propiedades del reporte head count*/
            let plantilla3 = []
            headCountParams.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla3.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla3.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setHeadCount(plantilla3)
        }
        HCTemplate()
    }, [headCountParams]);

    useEffect(() => {
        // const getBudget = async () => {
        //     try {
        //         await apis.getGetPayroll_budget(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
        //             let data = res.data;
        //             setLabelPayrollBudget(data.label)
        //             setDatasetsPayrollBudget(data.datasets)
        //             setNamePayrollBudget(data.name)
        //             setLoadPage(true)
        //         })
        //     }
        //     catch (error) {
        //         setLoadPage(true)
        //         console.log(error)
        //     };
        // }
        // getBudget()
        setTablaTab()
    }, []);

    let intervalId

    const interval = () => {
        intervalId = !intervalId && setInterval(() => {
            console.log(tipoLiquidacion)
            setWarningTable()
        }, 60000)

        if (!tipoLiquidacion) {
            console.log("Se cierra")
            clearInterval(intervalId);
        }
    }

    useEffect(() => {
        interval()
        return () => clearInterval(intervalId)
    }, [tipoLiquidacion])

    useEffect(() => {
        const VacationCycleTemplate = async () => {
            /*Se inicializan las propiedades del reporte histórico de salarios*/
            let plantilla5 = []
            vacationCycleParams.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla5.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla5.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setLibroVacaciones(plantilla5)
        }
        VacationCycleTemplate()
    }, [vacationCycleParams]);

    const barDataPayroll_budget = {
        labels: labelPayrollBudget,
        datasets: datasetsPayrollBudget
    };

    function handleSubmit(event) {
        event.preventDefault();
    }

    //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
    const renderHeader1 = () => {
        return (
            <div className="barra">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm"
                    style={{
                        width: "100%"
                    }}
                    />
                </IconField>
            </div>
        )
    }

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
        }

        //Limpiar e inicializar los filtros
        const clearFilter1 = () => {
        initFilters1();
    }

    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'LOV_REASON': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    /*Funciones que manejan el comportamiento de los modales del componente*/
    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        setTipoLiquidacion("")
        setConsultado(false)
        setIsOpen(false);
    };

    const showModalPB = () => {
        loadCalendar();
        setIsOpenPB(true);
    };

    const hideModalPB = () => {
        setIsOpenPB(false);
    };

    const showModalRN = () => {
        setIsOpenRN(true);
    };

    const hideModalRN = () => {
        setIsOpenRN(false);
    };

    const showModalHS = () => {
        setIsOpenHS(true);
    };

    const hideModalHS = () => {
        setIsOpenHS(false);
    };

    const showModalHC = () => {
        setIsOpenHC(true);
    };

    const hideModalHC = () => {
        setIsOpenHC(false);
    };

    const showModalAcum = () => {
        setIsOpenAcum(true);
    };

    const hideModalAcum = () => {
        setIsOpenAcum(false);
    };

    const showModalSB = () => {
        setIsOpenSB(true);
    };

    const hideModalSB = () => {
        setIsOpenSB(false);
    };

    const setWarningTable = async () => {
        const _calendario = tipoLiquidacion.value
        try {
            await apis.getWarning(localStorage.getItem('entity'), localStorage.getItem('client'), _calendario, headers).then(res => {
                let data = res.data.WARNING
                console.log(data)
                if (data.length > 0) {
                    let newData = []
                    data.forEach(row => {
                        let newRow = {
                            CONTRACT: row.LABEL.split(':')[1],
                            ...row
                        }
                        newData.push(newRow)
                    })
                    setWarningRows(newData)
                }
                else {
                    setWarningRows([])
                }
                setWarningType(res.data.STATUS)
                setTabla()
                setTablaTab()
            })
        }
        catch (err) {
            let msg = err.response
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: msg, sticky: true });
        }
    }
    const showModalVC = () => {
        setIsOpenVC(true);
    };

    const hideModalVC = () => {
        setIsOpenVC(false);
    };

    async function loadCalendar() {
        /*Función encargada de actualizar el calendario de liquidación de nómina*/
        await apis.getValueListCalendar("NM", headers).then(res => {
            let calendar = res.data.CALENDAR
            let contenidoCalendar = [];
            calendar.forEach(element =>
                contenidoCalendar.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
            )
            setListaLiquidacion(contenidoCalendar)
        })
        await apis.getLastCalendar(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
            let calendar = res.data.CALENDAR
            let contenidoCalendar = []
            calendar.forEach(element =>
                contenidoCalendar.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
            )
            setListaPlanoBancario(contenidoCalendar)
        })
    }

    const showConfirm = (id, process) => {
        /*Función encargada de mostrar al usuario un mensaje de confirmación de la realización de un proceso*/
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Proceso {process}({id}) realizado existosamente</p>
                    </div>
                </div>
            )
        });
    }

    async function process(action) {
        /*Función encargada de validar cuál proceso se desea realizar*/
        const _cliente = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const _calendario = tipoLiquidacion.value

        const p = {
            ID_CALENDAR: _calendario,
            ENTITY: _entity,
            CLIENT: _cliente,
            ACTION: action
        }
        let msg = ""
        if (action == "PRO") {
            msg = "Procesar"
        }
        else {
            if (action == "CLO") {
                msg = "Acumular"
            }
            else {
                if (action == "REV") {
                    msg = "Deshacer"
                }
            }
        }
        try {
            await apis.executeProcess(p, headers).then(res => {
                loadCalendar();
            })
            setTimeout(() => {
                apis.getExecutedProcess(_entity, _calendario, _cliente, action, headers).then(res => {
                    if (res.data.PROCESS.length > 0) {
                        let data = res.data.PROCESS[0]
                        if (data !== "") {
                            let id = data.ID
                            setLoading1(false)
                            setLoading2(false)
                            setLoading3(false)
                            showConfirm(id, msg)
                        }
                    }
                    else {
                        setLoading1(false)
                        setLoading2(false)
                        setLoading3(false)
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "No hay registros para el proceso", sticky: true });
                    }
                })
                setWarningTable()
                loadCalendar()
                setTablaTab()
                hideModalAcum()
            }, 1000)
        }
        catch (err) {
            msg = err.response.data.message
            setLoading1(false)
            setLoading2(false)
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: msg, sticky: true });
        }
    }

    async function bankFlat() {
        /*Función encargada de gnerar el archivo txt de plano bancario*/
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const date_pay = dateFormat(fechaPago)
        const id_last_calendar = tipoPlanoBancario.value
        try {
            await apis.getBankFlat(_entity, client, date_pay, id_last_calendar, headers).then(res => {
                let contenido = res.data["FLAT_FILES"]
                let planos = []
                contenido.forEach(file => {
                    if (file["DETAIL"].length > 0) {
                        let nombre = file.NAME
                        let contratos = file.TOTAL_CONTRACT
                        let total = file.TOTAL_VALUE
                        let lineas = ""
                        file["DETAIL"].forEach(element =>
                            lineas += element.LINE + "\r\n"
                        )
                        planos.push({
                            nombre,
                            contratos,
                            total,
                            lineas
                        })
                    }
                })
                setRowsPlano(planos)
                setLoading4(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Plano(s) bancario(s) generado exitosamente" });
                // hideModalPB()
                // const blob = new Blob([lineas], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
                loadCalendar();
                // saveAs(blob, nombre);
            })
        }
        catch (err) {
            setLoading4(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const flatDetail = (flat) => {
        const blob = new Blob([flat.lineas], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        saveAs(blob, flat.nombre);
    }

    async function postPayrollReport() {
        /*Función encargada de cargar la informacion del reporte de nómina*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: _entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        nomina.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        nomina.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {
            await apis.postReportPayroll(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteNomina")
                setLoading5(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de nómina generado existosamente" });
                hideModalRN();
            })
        }
        catch (err) {
            setLoading5(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postSalaryHistoryReport() {
        /*Función encargada de cargar la informacion del reporte histórico de salarios*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: _entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        historico.forEach(h => {
            let size = h.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        historico.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.postReportSalaryHistory(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteHistoricoSalarios")
                setLoading6(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte histórico de salarios generado existosamente" });
                hideModalHS();
            })
        }
        catch (err) {
            setLoading6(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postHeadCountReport() {
        /*Función encargada de cargar la informacion del reporte head count*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: _entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        headCount.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        headCount.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.postReportHeadCount(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteHeadCount")
                setLoading7(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte head count generado existosamente" });
                hideModalHC();
            })
        }
        catch (err) {
            setLoading7(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postSocialBenefitsReport() {
        /*Función encargada de cargar la informacion del reporte head count*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: _entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        prestaciones.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        prestaciones.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.socialBenefitsReport(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteConsolidadPrestaciones")
                setLoading10(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte consolidado de prestaciones generado existosamente" });
                hideModalSB();
            })
        }
        catch (err) {
            setLoading10(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postVacationCycleReport() {
        /*Función encargada de cargar la informacion del reporte head count*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: _entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        libroVaciones.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        libroVaciones.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.postVacationCycle(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteLibroDeVacaciones")
                setLoading11(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte libro de vacaciones generado existosamente" });
                hideModalVC();
            })
        }
        catch (err) {
            setLoading11(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    function exportWarningTable() {
        /*Función encargada de construir el archivo Excel del reporte*/
        let newData = []
        warningRows.forEach(warn => {
            let newWarn = {
                Contrato: warn.CONTRACT,
                Comentario: warn.OBSERVATION
            }
            newData.push(newWarn)
        })
        excelExport(newData, 'Warnings')
    }
    
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    
    async function setTabla() {
        const _calendario = tipoLiquidacion.value
        try {
            await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
                console.log("Se llama tabla modal")
                if (res.data["PROCESS"].length > 0) {
                    let data = res.data["PROCESS"]
                    setRows(data)
                    setRowData(data)
                    setEmployees(res.data.TOTAL_CONTRACT)
                    setNet(res.data.TOTAL_REMUNER)
                    setConsultado(true)
                }
                else {
                    setRows([])
                    setRowData([])
                    setEmployees("")
                    setNet("")
                }
                setLoading8(false)
                setLoading9(false)
            })
        }
        catch (err) {
            setLoading8(false)
            setLoading9(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const rowClassName = (rowData) => {
        return { 'error-row': (rowData["STATUS"] === "ERROR") };
    }

    const percentageBodyTemplate = (rowData) => {
        return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
    }

    const formatCurrency = (value) => {
        let currency = parseFloat(value)
        return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
    };

    const tableHeader = (
        <div className="table-header flex justify-content-between">
            <div className="flex align-items-center flex-row">
                <i className="pi pi-users mr-2" style={{ fontSize: '1.5rem' }}></i>
                <div className="flex align-items-start flex-column">
                    <span className="m-0">Número empleados: {employees}</span>
                    <span className="m-0">Neto: {net ? formatCurrency(net) : net}</span>
                </div>
            </div>
            <Button icon="pi pi-refresh" loading={loading8} tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm" onClick={() => { setLoading8(true); setWarningTable() }} />
        </div>
    );

    const tableHeader2 = (
        <div className="table-header flex justify-content-between">
            <Avatar icon={warningType === "RUNNING" ? "pi pi-spin pi-spinner-dotted" : "pi pi-exclamation-triangle"} size="large"
                style={{ backgroundColor: warningType === "RUNNING" ? '#2196F3' : 'red', color: '#ffffff' }} shape="circle" />
            <Button icon="pi pi-file-excel" label="Exportar" className="p-button-success mr-2 p-button-sm" onClick={() => { exportWarningTable() }} />
        </div>
    );

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const actionBodyTemplate = (rowData) => {
        console.log(rowData.ERRORS)
        return (
            <div>
                {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
            </div>
        )
    }


    const footerLN = (
        <>
            <div>
                <Button label="Procesar" style={{ marginLeft: "-1rem" }} loading={loading1} onClick={() => { setLoading1(true); process("PRO") }} disabled={tipoLiquidacion == false} />
                <Button label="Deshacer" loading={loading3} onClick={() => { setLoading3(true); process("REV") }} disabled={tipoLiquidacion == false} />
                <Button label="Acumular" onClick={showModalAcum} disabled={tipoLiquidacion == false} />
            </div>
            {consultado === true ?
                <div className="datatable-style-demo">
                    <DataTable className="text-xs" header={tableHeader} value={rows} first={first2} rows={rows2} onPage={onCustomPage2}
                        selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['ID', 'TRHEAD', 'JOB', 'RECORD', 'START', 'END', 'PROCESSED', 'ERROR', 'PERCENTAGE', 'ACTION', 'STATUS']}
                        rowClassName={rowClassName}
                    >
                        <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplate}></Column>
                        <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                        <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
                        <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
                        <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
                        <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
                        <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
                        <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
                        <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
                        <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
                    </DataTable>
                    {warningRows.length > 0 && <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

                        <DataTable className="text-xs" header={tableHeader2} value={warningRows} first={warningFirst2} rows={warningRows2} onPage={onCustomPage2}
                            dataKey="CONTRACT" size="small" paginator paginatorTemplate={template2}
                        >
                            <Column field="CONTRACT" header="Contrato" showFilterOperator={false}></Column>
                            <Column field="OBSERVATION" header="Comentario" showFilterOperator={false}></Column>
                        </DataTable>
                    </div>}
                </div>
                : null}
        </>
    );

    const actionBodyTemplatePlano = (rowData) => {
        return (
            <Button icon="pi pi-download" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Comprobante" tooltipOptions={{ position: 'top' }}
                onClick={() => {
                    flatDetail(rowData)
                }} />
        )
    }

    const totalBodyTemplatePlano = (rowData) => {
        return formatCurrency(rowData.total);
    }

    /*Headers y footers de los modales del componente*/
    const headerAcum = (
        <div>
            <h3>¿Desea realizar la acumulación del proceso?</h3>
        </div>
    )

    const footerAcum = (
        <div>
            <Button label="Si" loading={loading2} onClick={() => { setLoading2(true); process("CLO") }} />
            <Button label="No" onClick={hideModalAcum} />
        </div>
    );

    const headerLN = (
        <div>
            <h3>Seleccionar calendario para liquidación de nómina</h3>
        </div>
    )

    const footerPB = (
        <div>
            <Button label="Generar" loading={loading4} onClick={() => { setLoading4(true); bankFlat() }} disabled={tipoPlanoBancario == false || !fechaPago} />
            {rowsPlano.length > 0 && <DataTable className="text-xs" value={rowsPlano} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                dataKey="ID" size="small">
                <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                <Column field="nombre" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Nombre"></Column>
                <Column field="contratos" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Total contratos"></Column>
                <Column field="total" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Valor" body={totalBodyTemplatePlano}></Column>
                <Column header="Documento" headerStyle={{ width: '12rem', textAlign: 'center' }} body={actionBodyTemplatePlano}></Column>
            </DataTable>}
        </div>
    );

    const headerPB = (
        <div style={{ padingBotton: "-20px" }}>
            <h3>Seleccionar calendario para liquidación plano bancario</h3>
        </div>
    )

    const footerRN = (
        <div>
            <Button label="Generar" loading={loading5} onClick={() => { setLoading5(true); postPayrollReport() }} />
        </div>
    );

    const headerRN = (
        <div>
            <h3>Parámetros reporte de nómina</h3>
        </div>
    )

    const footerHS = (
        <div>
            <Button label="Generar" loading={loading6} onClick={() => { setLoading6(true); postSalaryHistoryReport() }} />
        </div>
    );

    const headerHS = (
        <div>
            <h3>Parámetros reporte histórico de salarios</h3>
        </div>
    )

    const footerHC = (
        <div>
            <Button label="Generar" loading={loading7} onClick={() => { setLoading7(true); postHeadCountReport() }} />
        </div>
    );

    const headerHC = (
        <div>
            <h3>Parámetros reporte head count</h3>
        </div>
    )

    const footerSB = (
        <div>
            <Button label="Generar" loading={loading10} onClick={() => { setLoading10(true); postSocialBenefitsReport() }} />
        </div>
    );

    const headerSB = (
        <div>
            <h3>Parámetros reporte consolidado de prestaciones</h3>
        </div>
    )

    const footerVC = (
        <div>
            <Button label="Generar" loading={loading11} onClick={() => { setLoading11(true); postVacationCycleReport() }} />
        </div>
    );

    const headerVC = (
        <div>
            <h3>Parámetros reporte libro de vacaciones</h3>
        </div>
    )


    /*Funciones que manejan el cambio en los campos de entrada del componente*/
    function handleChange(e, d, index) {
        setNomina(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    async function handleChangeDate(e, d, index) {
        let date = dateFormat(e.value)
        setNomina(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    async function handleChangeText(e, d, index) {
        setNomina(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    function handleChangeH(e, d, index) {
        setHistorico(h => {
            let newHistorico = [...h]
            newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeDateH(e, d, index) {
        let date = dateFormat(e.value)
        setHistorico(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeTextH(e, d, index) {
        setHistorico(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    function handleChangeHC(e, d, index) {
        setHeadCount(h => {
            let newHeadCount = [...h]
            newHeadCount[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHeadCount
        })
    }

    async function handleChangeDateHC(e, d, index) {
        let date = dateFormat(e.value)
        setHeadCount(h => {
            let newHeadCount = [...h]
            newHeadCount[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHeadCount
        })
    }

    async function handleChangeTextHC(e, d, index) {
        setHeadCount(h => {
            let newHeadCount = [...h]
            newHeadCount[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHeadCount
        })
    }

    function handleChangeSB(e, d, index) {
        setPrestaciones(h => {
            let newPrestaciones = [...h]
            newPrestaciones[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newPrestaciones
        })
    }

    async function handleChangeDateSB(e, d, index) {
        let date = dateFormat(e.value)
        setPrestaciones(h => {
            let newPrestaciones = [...h]
            newPrestaciones[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newPrestaciones
        })
    }

    async function handleChangeTextSB(e, d, index) {
        setPrestaciones(h => {
            let newPrestaciones = [...h]
            newPrestaciones[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newPrestaciones
        })
    }

    function handleChangeVC(e, d, index) {
        setLibroVacaciones(h => {
            let newPrestaciones = [...h]
            newPrestaciones[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newPrestaciones
        })
    }

    async function handleChangeDateVC(e, d, index) {
        let date = dateFormat(e.value)
        setLibroVacaciones(h => {
            let newPrestaciones = [...h]
            newPrestaciones[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newPrestaciones
        })
    }

    async function handleChangeTextVC(e, d, index) {
        setLibroVacaciones(h => {
            let newPrestaciones = [...h]
            newPrestaciones[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newPrestaciones
        })
    }

    const options = (nombre, tipo, grafica) => {
        const opciones = {
            plugins: {
                tooltip: {
                    position: 'average',
                    borderWidth: '100',
                    callbacks: {
                        labelTextColor: function (context) {
                            return 'white';
                        },
                        label: function (dataset) {
                            let label = dataset.label || '';
                            let data = dataset.parsed || '';
                            if (grafica !== "dona") {
                                data = dataset.parsed.y;
                            }

                            if (label) {
                                label += ': ';
                            }

                            if (tipo === 'currency') {
                                if (data !== null) {
                                    label += new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(data);
                                }
                            }
                            else {
                                label += data;
                            }
                            return label;
                        }
                    }
                },
                title: {
                    display: true,
                    text: nombre,
                    color: 'black',
                    font: {
                        size: '20',
                    },
                    padding: {
                        top: 0
                    }
                },
                legend: {
                    align: grafica === "dona" ? 'start' : 'center',
                }
            }
        }
        return opciones
    }

    async function setTablaTab() {
        await apis.getAdditionalCalendar(localStorage.getItem('entity'), localStorage.getItem('client'), "NM", headers).then(res => {
            console.log("Se llama tabla pantalla")
        if (res.data["CALENDARS"].length > 0) {
            const contenidoTabla = res.data["CALENDARS"]
            let contenido = []
            contenidoTabla.forEach(c => {
            let fila = c
            let estado = fila.STATUS.split('|')
            fila = {
                ...fila,
                STATUS: estado[1],
                STATUS_ID: estado[0]
            }
            contenido.push(fila)
            })
            setRowDataTab(contenido)
        } else {
            setRowDataTab([])
        }
        setLoadPage(true)
        }).catch(err => {
            setLoadPage(true)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message, sticky: true });
        })
    }

    const netBodyTemplatePlano = (rowData) => {
        if(rowData.TOTAL_REMUNER){
        return formatCurrency(rowData.TOTAL_REMUNER);
        }
        return rowData.TOTAL_REMUNER;
    }

    /*Renderizado del componente*/
    return (
        <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">

            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold mt-3 text-4xl">
                <span className="text-900">Liquidación</span>
                <Video header="Instructivo liquidación de nómina" url={localStorage.getItem('PAYROLLPAYMENT_VIDEO')} />
            </div>
            <ConfBar style={{ marginTop: "-2rem" }} />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Form onSubmit={handleSubmit}>
                <div className='cards' style={{ marginTop: "2rem" }}>
                    <Card className='shadow-5' style={{ width: '60vw' }}>
                        <SkeletonTable load={loadPage} height='60vh'>
                            {/* <Chart type="bar" data={barDataPayroll_budget} options={options(namePayrollBudget, 'currency', 'bar')} /> */}
                            <DataTable className="text-xs" value={rowDataTab} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                                scrollHeight="flex" dataKey="ID_ADDITIONAL"
                                size="small" filters={filters1} filterDisplay="menu" globalFilterFields={["ID_ADDITIONAL", 'ID_CALENDAR', 'YEAR', 'MONTH', 'DETAIL', 'LAPSE', 'OBSERVATION', 'STATUS']}
                                header={header1} >
                                <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                                <Column field="ID_ADDITIONAL" header="Id" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                                <Column field="ID_CALENDAR" header="Calendario" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
                                <Column field="TOTAL_CONTRACT" header="Número empleados" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
                                <Column field="TOTAL_REMUNER" header="Neto" body={netBodyTemplatePlano} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
                                <Column field="YEAR" header="Año" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por año" sortable></Column>
                                <Column field="MONTH" header="Mes" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por mes" sortable></Column>
                                <Column field="DETAIL" header="Período" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por período" sortable></Column>
                                <Column field="LAPSE" header="Lapso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por lapso" sortable></Column>
                                <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
                            </DataTable>
                        </SkeletonTable>
                    </Card>
                    &nbsp;
                    <Card className='card2 shadow-5'>
                        <Dialog header={headerLN} footer={footerLN} visible={isOpen} maximizable
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                            <LabelField htmlFor="label">Calendario liquidación de nómina *</LabelField>
                            <div className="p-inputgroup">
                                <Dropdown style={elementWidth} value={tipoLiquidacion.value}
                                    filter showClear filterBy="label" emptyMessage={"No hay calendarios disponibles"}
                                    options={listaLiquidacion} placeholder={"Seleccione calendario"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setTipoLiquidacion({ "value": e.value, "label": label })
                                    }}
                                />
                                <Button icon="pi pi-search" loading={loading9} className="mr-2 p-button-sm text-xs"
                                    tooltip="Consultar procesos anteriores" tooltipOptions={{ position: 'top' }}
                                    onClick={() => { setLoading9(true); setWarningTable() }} disabled={tipoLiquidacion == false} />
                            </div>
                        </Dialog>
                        <Dialog header={headerAcum} footer={footerAcum} visible={isOpenAcum} position="top"
                            style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalAcum} />
                        <Dialog header={headerPB} footer={footerPB} visible={isOpenPB}
                            position="top" style={{ width: "40vw" }} draggable={false} resizable={false} modal onHide={hideModalPB}>
                            <div>
                                <div style={{ width: "100%", paddingBottom: "20px" }}>
                                    <span style={{ fontSize: "0.8rem" }}>* Recuerda que debes acumular la nómina para poder generar el plano bancario.</span>
                                </div>
                                <span style={{ fontSize: "0.8rem", fontWeight: "900" }}>Campos obligatorios (*)</span>
                            </div>
                            <div>
                                <LabelField htmlFor="label">Calendario liquidación plano bancario *</LabelField>
                                <Dropdown style={elementWidth} value={tipoPlanoBancario.value}
                                    filter showClear filterBy="label" emptyMessage={"No hay calendarios disponibles"}
                                    options={listaPlanoBancario} placeholder={"Seleccione calendario"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setTipoPlanoBancario({ "value": e.value, "label": label })
                                    }}
                                />
                            </div>
                            <div>
                                <LabelField htmlFor="label">Fecha pago plano bancario *</LabelField>
                                <Calendar style={elementWidth} id="navigators" value={fechaPago}
                                    onChange={(e) => setFechaPago(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaPago}
                                    yearRange="2010:2030"
                                />
                            </div>
                        </Dialog>
                        <Dialog header={"Errores"} visible={isOpenErrors}
                            position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
                            <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

                                <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
                                    <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
                                    <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
                                </DataTable>
                            </div>
                        </Dialog>
                        <H3>Nómina</H3>
                        <Dialog header={headerRN} footer={footerRN} visible={isOpenRN} bo
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalRN}>
                            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                            {params.map((d, index) => {
                                /*Genera dinámica de los campos de entrada para el reporte de nómina*/
                                if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && nomina.length > 0 && typeof nomina[index] !== "undefined") {
                                    let label = d.LABEL;
                                    if (d.REQUIRED === "1") {
                                        label = label + "*"
                                    }
                                    switch (d.TYPE) {
                                        case "LIST":
                                            let options = []
                                            if (d.REQUIRED === "1") {
                                                options = [...d.OPTIONS]
                                            }
                                            else {
                                                options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                            }
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Dropdown
                                                    key={index}
                                                    style={elementWidth}
                                                    value={nomina[index]["NAME"]}
                                                    options={options}
                                                    filter showClear filterBy="NAME"
                                                    optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                                    //optionTemplate={optionTemplate}
                                                    placeholder={nomina[index]["NAME"] ? nomina[index]["NAME"] : "Seleccione"}
                                                    onChange={(e) => handleChange(e, d, index)}
                                                />
                                            </>
                                            );
                                        case "DATE":
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Calendar key={d} style={elementWidth} id="navigators" value={nomina[index].CODE}
                                                    onChange={(e) => handleChangeDate(e, d, index)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={nomina[index].CODE}
                                                    yearRange="2010:2030" /></>
                                            );
                                        default:
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <InputText
                                                    key={d}
                                                    style={elementWidth}
                                                    id="label2"
                                                    type="text"
                                                    value={nomina[index]}
                                                    onChange={(e) => handleChangeText(e, d, index)}
                                                /></>
                                            )
                                    }
                                }
                            })}
                        </Dialog>
                        <Dialog header={headerHS} footer={footerHS} visible={isOpenHS} bo
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalHS}>
                            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                            {salaryParams.map((d, index) => {
                                /*Genera dinámica de los campos de entrada para el reporte histórico de salarios*/
                                if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historico.length > 0 && typeof historico[index] !== "undefined") {
                                    let label = d.LABEL;
                                    if (d.REQUIRED === "1") {
                                        label = label + "*"
                                    }
                                    switch (d.TYPE) {
                                        case "LIST":
                                            let options = []
                                            if (d.REQUIRED === "1") {
                                                options = [...d.OPTIONS]
                                            }
                                            else {
                                                options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                            }
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Dropdown
                                                    key={index}
                                                    style={elementWidth}
                                                    value={historico[index]["NAME"]}
                                                    options={options}
                                                    filter showClear filterBy="NAME"
                                                    optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                                    //optionTemplate={optionTemplate}
                                                    placeholder={historico[index]["NAME"] ? historico[index]["NAME"] : "Seleccione"}
                                                    onChange={(e) => handleChangeH(e, d, index)}
                                                />
                                            </>
                                            );
                                        case "DATE":
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Calendar key={d} style={elementWidth} id="navigators" value={historico[index].CODE}
                                                    onChange={(e) => handleChangeDateH(e, d, index)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historico[index].CODE}
                                                    yearRange="2010:2030" /></>
                                            );
                                        default:
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <InputText
                                                    key={d}
                                                    style={elementWidth}
                                                    id="label2"
                                                    type="text"
                                                    value={historico[index]}
                                                    onChange={(e) => handleChangeTextH(e, d, index)}
                                                /></>
                                            )
                                    }
                                }
                            })}
                        </Dialog>
                        <Dialog header={headerHC} footer={footerHC} visible={isOpenHC} bo
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalHC}>
                            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                            {headCountParams.map((d, index) => {
                                /*Genera dinámica de los campos de entrada para el reporte head count*/
                                if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && headCount.length > 0 && typeof headCount[index] !== "undefined") {
                                    let label = d.LABEL;
                                    if (d.REQUIRED === "1") {
                                        label = label + "*"
                                    }
                                    switch (d.TYPE) {
                                        case "LIST":
                                            let options = []
                                            if (d.REQUIRED === "1") {
                                                options = [...d.OPTIONS]
                                            }
                                            else {
                                                options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                            }
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Dropdown
                                                    key={index}
                                                    style={elementWidth}
                                                    value={headCount[index]["NAME"]}
                                                    options={options}
                                                    filter showClear filterBy="NAME"
                                                    optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                                    //optionTemplate={optionTemplate}
                                                    placeholder={headCount[index]["NAME"] ? headCount[index]["NAME"] : "Seleccione"}
                                                    onChange={(e) => handleChangeHC(e, d, index)}
                                                />
                                            </>
                                            );
                                        case "DATE":
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Calendar key={d} style={elementWidth} id="navigators" value={headCount[index].CODE}
                                                    onChange={(e) => handleChangeDateHC(e, d, index)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={headCount[index].CODE}
                                                    yearRange="2010:2030" /></>
                                            );
                                        default:
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <InputText
                                                    key={d}
                                                    style={elementWidth}
                                                    id="label2"
                                                    type="text"
                                                    value={headCount[index]}
                                                    onChange={(e) => handleChangeTextHC(e, d, index)}
                                                /></>
                                            )
                                    }
                                }
                            })}
                        </Dialog>
                        <Dialog header={headerSB} footer={footerSB} visible={isOpenSB}
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalSB}>
                            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                            {socialBenefitsParams.map((d, index) => {
                                /*Genera dinámica de los campos de entrada para el reporte head count*/
                                if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && prestaciones.length > 0 && typeof prestaciones[index] !== "undefined") {
                                    let label = d.LABEL;
                                    if (d.REQUIRED === "1") {
                                        label = label + "*"
                                    }
                                    switch (d.TYPE) {
                                        case "LIST":
                                            let options = []
                                            if (d.REQUIRED === "1") {
                                                options = [...d.OPTIONS]
                                            }
                                            else {
                                                options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                            }
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Dropdown
                                                    key={index}
                                                    style={elementWidth}
                                                    value={prestaciones[index]["NAME"]}
                                                    options={options}
                                                    filter showClear filterBy="NAME"
                                                    optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                                    //optionTemplate={optionTemplate}
                                                    placeholder={prestaciones[index]["NAME"] ? prestaciones[index]["NAME"] : "Seleccione"}
                                                    onChange={(e) => handleChangeSB(e, d, index)}
                                                />
                                            </>
                                            );
                                        case "DATE":
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Calendar key={d} style={elementWidth} id="navigators" value={prestaciones[index].CODE}
                                                    onChange={(e) => handleChangeDateSB(e, d, index)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={prestaciones[index].CODE}
                                                    yearRange="2010:2030" /></>
                                            );
                                        default:
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <InputText
                                                    key={d}
                                                    style={elementWidth}
                                                    id="label2"
                                                    type="text"
                                                    value={prestaciones[index].CODE}
                                                    onChange={(e) => handleChangeTextSB(e, d, index)}
                                                /></>
                                            )
                                    }
                                }
                            })}
                        </Dialog>
                        <Dialog header={headerVC} footer={footerVC} visible={isOpenVC}
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalVC}>
                            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                            {vacationCycleParams.map((d, index) => {
                                /*Genera dinámica de los campos de entrada para el reporte head count*/
                                if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && libroVaciones.length > 0 && typeof libroVaciones[index] !== "undefined") {
                                    let label = d.LABEL;
                                    if (d.REQUIRED === "1") {
                                        label = label + "*"
                                    }
                                    switch (d.TYPE) {
                                        case "LIST":
                                            let options = []
                                            if (d.REQUIRED === "1") {
                                                options = [...d.OPTIONS]
                                            }
                                            else {
                                                options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                            }
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Dropdown
                                                    key={index}
                                                    style={elementWidth}
                                                    value={libroVaciones[index]["NAME"]}
                                                    options={options}
                                                    filter showClear filterBy="NAME"
                                                    optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                                    //optionTemplate={optionTemplate}
                                                    placeholder={libroVaciones[index]["NAME"] ? libroVaciones[index]["NAME"] : "Seleccione"}
                                                    onChange={(e) => handleChangeVC(e, d, index)}
                                                />
                                            </>
                                            );
                                        case "DATE":
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <Calendar key={d} style={elementWidth} id="navigators" value={libroVaciones[index].CODE}
                                                    onChange={(e) => handleChangeDateVC(e, d, index)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={libroVaciones[index].CODE}
                                                    yearRange="2010:2030" /></>
                                            );
                                        default:
                                            return (<>
                                                <LabelField htmlFor="label">{label}</LabelField>
                                                <InputText
                                                    key={d}
                                                    style={elementWidth}
                                                    id="label2"
                                                    type="text"
                                                    value={libroVaciones[index].CODE}
                                                    onChange={(e) => handleChangeTextVC(e, d, index)}
                                                /></>
                                            )
                                    }
                                }
                            })}
                        </Dialog>
                        <div className='flex flex-column justify-content-center align-items-center'>
                            <Button block type="submit" onClick={showModal}>
                                Liquidar nómina
                            </Button>
                            &nbsp;
                            <Button block type="submit" onClick={showModalPB}>
                                Plano bancario
                            </Button>
                            &nbsp;
                            <Button block type="submit" onClick={() => history.push("/OpenPayroll")}>
                                Ver nómina abierta
                            </Button>
                            &nbsp;
                        </div>
                        <H3>Consulta</H3>
                        <div className='flex flex-column justify-content-center align-items-center'>
                            <Button block type="submit" onClick={showModalRN}>
                                Reporte de nómina
                            </Button>
                            &nbsp;
                            <Button block type="submit" onClick={showModalSB}>
                                Consolidado de prestaciones
                            </Button>
                            &nbsp;
                            <Button block type="submit" onClick={showModalHS}>
                                Histórico de salarios
                            </Button>
                            &nbsp;
                            <Button block type="submit" onClick={showModalHC}>
                                Head count
                            </Button>
                            &nbsp;
                            <Button block type="submit" onClick={showModalVC}>
                                Libro de vacaciones
                            </Button>
                        </div>
                    </Card>
                </div>
            </Form>
        </div>
    );
}